// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"f2a7680d","471":"a1c72cb0","488":"5e6baf0b"}[chunkId] + ".chunk.js";
};